"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmTextArea = void 0;
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const Icon_1 = require("../Icon");
exports.SmTextArea = (0, react_1.forwardRef)((_a, ref) => {
    var { id, label, srOnly, message, messageIcon = (react_1.default.createElement(Icon_1.SmIcon, { name: "error_outline", size: "small", type: "outlined" })), invalid, className } = _a, props = __rest(_a, ["id", "label", "srOnly", "message", "messageIcon", "invalid", "className"]);
    const fieldClassName = (0, classnames_1.default)('c-field -search', {
        '-disabled': props.disabled,
        '-invalid': invalid,
    }, className);
    const fieldLabelClassName = (0, classnames_1.default)('c-field__label', {
        '-hidden': srOnly,
    });
    const controlClassName = 'c-control -search -textArea';
    const inputClassName = (0, classnames_1.default)('c-control__input', '-noIcon');
    return (react_1.default.createElement("div", { className: fieldClassName },
        react_1.default.createElement("label", { className: fieldLabelClassName, htmlFor: id }, label),
        react_1.default.createElement("div", { className: controlClassName },
            react_1.default.createElement("textarea", Object.assign({}, props, { id: id, ref: ref, className: inputClassName, disabled: props.disabled, "aria-describedby": message ? `${id}-description` : '' }))),
        message && (react_1.default.createElement("small", { id: `${id}-description`, className: "c-field__description" },
            messageIcon,
            message))));
});
//# sourceMappingURL=index.js.map